import React, { useEffect } from 'react';

import {
    VStack,
    Flex,
    Image,
    Spacer,
    Button,
    Divider,
    HStack,
    Avatar,
    Text,
    Tooltip
} from '@chakra-ui/react';

import {
    VscCheck,
    VscNote,
    VscOrganization,
    VscMirror,
    VscFeedback,
    VscSearch,
    VscShield,
    VscRobot
} from 'react-icons/vsc';

import SideBarButton from '../Atoms/SideBarButton';

import Const from '../Constants';

import { handleSubscribe } from '../Utils';

import pkg from '../../package.json';
const { version } = pkg;

const SideBar = ({ auth, appMode, setAppMode, setIsSignedIn, subscription, isAdmin }) => {
    useEffect(() => {
        // Manually initialize Lemon.js after the component has mounted
        window.createLemonSqueezy();
    }, []);

  return (
    <VStack
        width={'240px'}
        minW={'240px'}
        maxW={'240px'}
        background={Const.Gray46}
        padding={'10px'}
        h={'100vh'}
        spacing={'8px'}
        borderRight={'1px solid'}
        borderColor={Const.Gray64}
    >
        <HStack
            data-tour={'profile'}
            w={'100%'}
            paddingLeft={2}
            style={{ cursor: Const.sPointer }}
            onClick={() => {
                setAppMode(Const.sProfile);
            }}
        >
            <Avatar
                src={(auth && auth.currentUser) ? auth.currentUser.photoURL : ''}
                size={Const.SM}
                borderWidth={2}
            />
            <Text
                fontSize={Const.SM}
                fontWeight={Const.Bold}
                color={Const.White}
                marginLeft={1}
            >
                {auth && auth.currentUser && auth.currentUser.displayName}
            </Text>
        </HStack>
        <Divider borderColor={Const.Gray100} />

        {/* People & cadences */}
        <SideBarButton
            dataTour={'one-on-ones'}
            current={appMode === Const.s1on1Meetings}
            icon={<VscMirror/>}
            title={Const.s1on1Meetings}
            action={() => setAppMode(Const.s1on1Meetings)}
        />

        <SideBarButton
            dataTour={'meetings'}
            current={appMode === Const.sMeetings}
            icon={<VscOrganization/>}
            title={Const.sMeetings}
            action={() => setAppMode(Const.sMeetings)}
        />

        <SideBarButton
            dataTour={'interviews'}
            current={appMode === Const.sInterviews}
            icon={<VscSearch/>}
            title={Const.sInterviews}
            action={() => setAppMode(Const.sInterviews)}
        />

        <Divider my={1} borderColor={Const.Gray100} />

        {/* Your work */}
        <SideBarButton
            dataTour={'tasks'}
            current={appMode === Const.sTasks}
            icon={<VscCheck/>}
            title={Const.sTasks}
            action={() => setAppMode(Const.sTasks)}
        />

        <SideBarButton
            dataTour={'notes'}
            current={appMode === Const.sNotes}
            icon={<VscNote/>}
            title={Const.sNotes}
            action={() => setAppMode(Const.sNotes)}
        />

        <Divider my={1} borderColor={Const.Gray100} />

        {/* AI */}
        <SideBarButton
            dataTour={'agents'}
            current={appMode === Const.sAgents}
            icon={<VscRobot/>}
            title={Const.sAgents}
            action={() => setAppMode(Const.sAgents)}
        />
        
        <Spacer/>
        {isAdmin && (
            <SideBarButton
                current={appMode === Const.sAdmin}
                icon={<VscShield/>}
                title={Const.sAdmin}
                action={() => setAppMode(Const.sAdmin)}
            />
        )}
        <SideBarButton
            current={appMode === Const.sFeedback}
            icon={<VscFeedback/>}
            title={Const.sFeedback}
            action={() => setAppMode(Const.sFeedback)}
        />
        <Divider my={1} borderColor={Const.Gray100} />
        <HStack>
            <Flex
                align={Const.sCenter}
                justify={Const.sCenter}>
                    <a href='https://flowhero.ai' target='_blank' rel='noreferrer'>
                        <Image src='logo-white.svg' height={'22px'} />
                    </a>
            </Flex>
            { false && subscription.state === false && // TODO remove the false that disables the logic
                <Button
                    size={Const.SM}
                    height={'30px'}
                    background={Const.ActiveColor}
                    color={Const.White}
                    _hover={{ background: Const.DoneLightColor }}
                    fontSize={Const.SM}
                    onClick={
                        () => { handleSubscribe(auth.currentUser.uid);        
                    }}
                >
                    Subscribe
                </Button>
            }
            {
            false && <Tooltip label={`Thank you for trying the alpha version of ${Const.sAppName}. We appreciate the feedback!`}>
                <Text
                    fontSize={Const.XXS}
                    fontWeight={Const.Bold}
                    color={Const.White}
                    background={Const.ActiveColor}
                    borderRadius={Const.LG}
                    paddingLeft={2}
                    paddingRight={2}
                    style={{
                        cursor: Const.sDefault,
                        userSelect: Const.sNone
                    }}
                >
                    {version} alpha
                </Text>
            </Tooltip>
            }
        </HStack>
    </VStack>
  );
};

export default SideBar;
